/**
 * Intro Content Block
 *
 * Scrolls to the next section when the down arrow is clicked. With a
 * destination ID set the arrow is a plain anchor and the theme's global smooth
 * scrolling handles it (resources/js/global.js); without one it is a button,
 * and the section that follows the block has to be found here.
 *
 * The block previews as a decorative arrow in the editor, so there is nothing
 * for this to bind to there.
 */

// Matches the breathing room the theme's anchor links leave below the header.
const HEADER_GAP = 20;

function prefersReducedMotion() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// Skips scripts, comments-turned-markup and empty wrappers between blocks —
// anything that would scroll the reader to nothing.
function isSection(element) {
    return element.getClientRects().length > 0 && element.offsetHeight > 0;
}

function findNextSection(arrow) {
    let node = arrow.closest('.intro-content') || arrow;

    // Blocks are siblings in <main>, so the next one is usually right there.
    // Climbing covers the last block on a page — whose next section is the
    // footer — and any wrapper a template puts around the blocks.
    while (node && node !== document.body) {
        for (let sibling = node.nextElementSibling; sibling; sibling = sibling.nextElementSibling) {
            if (isSection(sibling)) return sibling;
        }

        node = node.parentElement;
    }

    return null;
}

function scrollToSection(section) {
    const header = document.querySelector('.header');
    const top = Math.max(
        0,
        section.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0) - HEADER_GAP,
    );

    if (window.lenis) {
        window.lenis.scrollTo(top, { duration: 1.5 });
    } else {
        window.scrollTo({ top, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }
}

function initIntroContent(scope) {
    const root = scope || document;

    root.querySelectorAll('[data-intro-scroll]').forEach((arrow) => {
        if (arrow.dataset.introScrollReady) return;
        arrow.dataset.introScrollReady = 'true';

        arrow.addEventListener('click', () => {
            // Resolved on click rather than up front, so blocks that load or
            // collapse after this runs are still counted.
            const section = findNextSection(arrow);

            if (section) scrollToSection(section);
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initIntroContent(), { once: true });
} else {
    initIntroContent();
}
